module.exports = __webpack_public_path__ + "img/loading.9ea6db7f.png";